<template>
    <h1>Planowane wyłączenia - panel akceptującego</h1>
    <PlannedOutageAcceptSearchCriteria ref="plannedOutageAcceptSearchCriteria" v-model="searchCriteria"
                                       @update:modelValue="search" @confirmDelete="deleteSelectedOutages" />
    <PlannedOutageAcceptTable ref="plannedOutageAcceptTable" :search-criteria="searchCriteria" />
</template>

<script>
    import {SearchCriteria} from "@/utils/SearchCriteria";
    import PlannedOutageAcceptSearchCriteria from "./components/PlannedOutageAcceptSearchCriteria";
    import PlannedOutageAcceptTable from "./components/PlannedOutageAcceptTable";

    export default {
        name: "PlannedOutageAcceptView",

        components: {
            PlannedOutageAcceptSearchCriteria,
            PlannedOutageAcceptTable,
        },

        data() {
            return {
                searchCriteria: this.getClearSearchCriteria(),
            };
        },

        beforeMount() {
            SearchCriteria.loadCriteria(this);
        },

        methods: {
            search() {
                SearchCriteria.updateUrl(this);

                this.$refs.plannedOutageAcceptTable.search();
            },

            clear() {
                this.searchCriteria = this.getClearSearchCriteria();
            },

            getClearSearchCriteria() {
                return {
                    id: null,
                    addresses: {address: ""},
                    outageStart: null,
                    deleted: false,
                    page: {
                        limit: 10,
                        offset: 0,
                        sortField: null,
                        sortOrder: null,
                    },
                };
            },

            deleteSelectedOutages() {
                this.$refs.plannedOutageAcceptTable.deleteSelectedOutages();
            },
        },
    };
</script>

<style lang="less" scoped>

</style>
